export const ConsumerPhoneValidationErrorBadRequestStyles = {
  errorMessage: 'py-4'
}
